import { KYMW7200Component } from './kymw7200.component';
import { OperationGoodsListModel } from './vo/operation-goods-list.model';

/**
 * 運営商品一覧画面の値を管理するクラス
 *
 * @export KYMW7200Model
 * @class KYMW7200Model
 */
export class KYMW7200Model {

  kymw7200Component: KYMW7200Component;

  // 親画面からの連携値
  param: any;
  /** 宅配業態. */
  public deliveryDiv: string = <string>'1';
  /** 注文コード */
  public orderNum: string;
  /** 受注企画回*/
  public orderCatalog: string;
  /** 運営企画区分. */
  public planningManagementDiv: string = <string>'';
  /** 運営企画詳細区分. */
  public planningManagementDetailDiv: string = <string>'';
  /** 商品名. */
  public goodsName: string = <string>'';
  /** 規格名. */
  public standardName: string = <string>'';
  // 運営商品一覧の開始件数
  public startDispNum = Number(0);
  // 運営商品一覧の終了件数
  public endDispNum = Number(0);
  // 運営商品一覧の総件数
  public totalNum = Number(0);
  // 共通機能（ページネーション）
  public prevDisabled: boolean = true;
  public nextDisabled: boolean = true;
  // 運営商品一覧の現在ページ
  public page: string = <string>'1';
  // 選択アイテムコード
  public selectedoperationGoodsIds: string[] = [];
  // データリスト
  public operationGoodsListData: OperationGoodsListModel[] = [];
  
  public setReserveNum1: string = <string>'';
  public setCodeDiv: string = <string>"";
  
  // 検索条件保持用の変数
  public searchDeliveryDiv: string = <string>'';
  public searchOrderNum: string = <string>'';
  public searchPlanningManagementDiv: string = <string>'';
  public searchGoodsName: string = <string>'';
  public searchOrderCatalog: string = <string>'';
  public searchSetCodeDiv: string = <string>'';
  public searchPlanningManagementDetailDiv: string = <string>'';
  public searchStandardName: string = <string>'';

  public setDisplayResult(serverData: any): void {

    // ページング関連項目初期化
    this.totalNum = Number(serverData.TotalNum);
    this.startDispNum = Number(serverData.StartDispNum);
    this.endDispNum = Number(serverData.EndDispNum);

    // 全件数と当該ページ最終行番号の比較
    // 全件数が当該ページ最終行番号より大きい場合、次へボタンを有効化
    if (this.totalNum > this.endDispNum) { // 次ページデータありの場合
      // 活性制御
      this.nextDisabled = false; // 次へボタン
    } else {  // 次ページデータなしの場合
      // 活性制御
      this.nextDisabled = true; // 次へボタン
    }

    // 当該ページ先頭行番号のチェック
    // 当該ページ先頭行番号が１より大きい場合、前へボタンの有効化制御
    if (this.startDispNum > 1) { // 前ページデータありの場合
      // 活性制御
      this.prevDisabled = false; // 前へボタン
    } else { // 前ページデータなしの場合
      // 活性制御
      this.prevDisabled = true; // 前へボタン
    }

    // tempデータリスト
    const tempList = Array<any>();
    // nullチェック
    if (serverData == null) {
      return null;
    }

    // // 1件ずつ処理
    for (let i = Number(0); i < serverData.OperationGoodsList.length; i++) {
      tempList.push({
        targetFlg: false,
        operationGoodsId: serverData.OperationGoodsList[i].OperationGoodsId,
        operationGoodsStatusCode: serverData.OperationGoodsList[i].OperationGoodsStatusCode,
        operationGoodsStatusName: serverData.OperationGoodsList[i].OperationGoodsStatusName,
        deliveryDivCode: serverData.OperationGoodsList[i].DeliveryDivCode,
        deliveryDivName: serverData.OperationGoodsList[i].DeliveryDivName,
        orderNum: serverData.OperationGoodsList[i].OrderNum,
        coopCodeList: serverData.OperationGoodsList[i].CoopCodeList,
        planningManagementDivCode: serverData.OperationGoodsList[i].PlanningManagementDivCode,
        planningManagementDivName: serverData.OperationGoodsList[i].PlanningManagementDivName,
        planningManagementDetailDivCode: serverData.OperationGoodsList[i].PlanningManagementDetailDivCode,
        planningManagementDetailDivName: serverData.OperationGoodsList[i].PlanningManagementDetailDivName,
        orderReceptionStartCatalog: serverData.OperationGoodsList[i].OrderReceptionStartCatalog,
        orderReceptionEndCatalog: serverData.OperationGoodsList[i].OrderReceptionEndCatalog,
        depositCapitalIncreasePatternCode: serverData.OperationGoodsList[i].DepositCapitalIncreasePatternCode,
        depositCapitalIncreasePatternName: serverData.OperationGoodsList[i].DepositCapitalIncreasePatternName,
        depositCapitalIncreaseCount: serverData.OperationGoodsList[i].DepositCapitalIncreaseCount,
        unitPrice: serverData.OperationGoodsList[i].UnitPrice,
        formFlyerCode: serverData.OperationGoodsList[i].FormFlyerCode,
        pointNumber: serverData.OperationGoodsList[i].PointNumber,
        pauseGroupCode: serverData.OperationGoodsList[i].PauseGroupCode,
        pdDivCode: serverData.OperationGoodsList[i].PdDivCode,
        pdDivName: serverData.OperationGoodsList[i].PdDivName,
        deliveryLeadDivCode: serverData.OperationGoodsList[i].DeliveryLeadDivCode,
        deliveryLeadDivName: serverData.OperationGoodsList[i].DeliveryLeadDivName,
        goodsName: serverData.OperationGoodsList[i].GoodsName,
        goodsNameKana: serverData.OperationGoodsList[i].GoodsNameKana,
        standardName: serverData.OperationGoodsList[i].StandardName,
        standardNameKana: serverData.OperationGoodsList[i].StandardNameKana,
        appropriatingClassCode: serverData.OperationGoodsList[i].AppropriatingClassCode,
        appropriatingClassName: serverData.OperationGoodsList[i].AppropriatingClassName,
        consumeTaxDivCode: serverData.OperationGoodsList[i].ConsumeTaxDivCode,
        consumeTaxDivName: serverData.OperationGoodsList[i].ConsumeTaxDivName,
        consumeTaxRate: serverData.OperationGoodsList[i].ConsumeTaxRate,
      });
    }
    this.operationGoodsListData = tempList;
  }
}
